import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import './scss/index.scss';
import * as utils from '@/server/utils';

export default class InquiryDetails extends React.Component <any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			id: utils.getQueryString('id'),
			detailsData: '',
			viewImgVisible: false,
			viewImgSrc: ''
		};
	}

	componentDidMount() {
		this.getDetailsData();
	}

	render() {
		const { detailsData } = this.state;
		return (
			<div className="page-inquiryDetails">
				<div className="default-card-list">
					<h2>产品信息</h2>
					<div className="default-card">
					<ul className="card-contetn">
						<li className="card-row">
						<span className="label">索样产品</span>
								<span className="text line-clamp-1">{ detailsData.goods_name }</span>
						</li>
						{/*<li className="card-row">
						<span className="label">型号</span>
								<span className="text line-clamp-1">{ detailsData.grade }</span>
						</li>*/}
						<li className="card-row">
						<span className="label">应用领域</span>
						<span className="text line-clamp-1">{ detailsData.application_area }</span>
						</li>
						<li className="card-row">
						<span className="label">品质要求</span>
						<span className="text line-clamp-1">{ detailsData.quality }</span>
						</li>
						{/*<li className="card-row">
						<span className="label">生产商</span>
						<span className="text line-clamp-1">{ detailsData.manufacturer }</span>
						</li>
						<li className="card-row">
						<span className="label">货源要求</span>
						<span className="text line-clamp-1">{ ['不限', '贸易商渠道', '厂家直供'][detailsData.supply-1] }</span>
						</li>
						<li className="card-row">
						<span className="label">包装形式</span>
						<span className="text line-clamp-1">{ detailsData.packing }</span>
						</li>*/}
					</ul>
					</div>
					<h2>拿样信息</h2>
					<div className="default-card">
					<ul className="card-contetn">
						<li className="card-row">
						<span className="label">拿样数量</span>
						<span className="text line-clamp-1">{ detailsData.number }</span>
						</li>
					</ul>
					</div>
					<h2>收货信息</h2>
					<div className="default-card">
					<ul className="card-contetn">
						<li className="card-row">
						<span className="label">企业名称</span>
						<span className="text">{ detailsData.user_company }</span>
						</li>
						<li className="card-row">
						<span className="label">收货信息</span>
								<span className="text">{detailsData.province_str}{detailsData.city_str}{detailsData.district_str}{ detailsData.address}</span>
						</li>
						<li className="card-row">
						<span className="label">联系电话</span>
						<span className="text line-clamp-1">{ detailsData.user_tel }</span>
						</li>
						<li className="card-row">
						<span className="label">收货人姓名</span>
						<span className="text line-clamp-1">{ detailsData.user_linkman }</span>
						</li>
					</ul>
					</div>
					<h2>物流信息</h2>
					{
						detailsData.delivery_order ?
						<div className="default-card">
				            <ul className="card-contetn">
				              <li className="card-row">
				                <span className="label">物流公司</span>
				                <span className="text line-clamp-1">{detailsData.delivery_company}</span>
				              </li>
				              <li className="card-row">
				                <span className="label">物流单号</span>
				                <span className="text line-clamp-1">{detailsData.delivery_order}</span>
				              </li>
				              <li className="card-row">
				                <span className="label">寄出时间</span>
				                <span className="text line-clamp-1">{detailsData.delivery_at}</span>
				              </li>
				              {
				              	detailsData.delivery_img ? <li className="card-row">
				                <img src={detailsData.delivery_img} alt="" className="see-pic" onClick={() => this.toggleViewImg(detailsData.delivery_img_source, true)}/>
				              </li> : null
				              }
				            </ul>
				          </div>
						: <div className="default-card"><p className="bz">暂无</p></div>
					}
					
					<h2>试用反馈</h2>
					<div className="default-card">
			            <ul className="card-contetn">
			              <li className="card-row">
			                <span className="label">签收时间</span>
			                <span className="text line-clamp-1">{ detailsData.receiving_at }</span>
			              </li>
			              <li className="card-row">
			                <span className="label">是否已试验</span>
			                <span className="text line-clamp-1">{ detailsData.is_trial }</span>
			              </li>
			              <li className="card-row">
			                <span className="label">试验结果</span>
			                <span className="text">{ detailsData.trial_results }</span>
			              </li>
			              <li className="card-row">
			                <span className="label">试样产品改进建议</span>
			                <span className="text">{ detailsData.suggest }</span>
			              </li>
			              {
			              	detailsData.feedback_img ?
			              	<li className="card-row">
				                <img src={ detailsData.feedback_img } alt="" className="see-pic" onClick={() => this.toggleViewImg(detailsData.feedback_img_source, true)}/>
				              </li> : null
			              }
			            </ul>
			          </div> 					
					<h2>留言</h2>
					<div className="default-card">
					<p className="bz">{ detailsData.message || '暂无' }</p>
					</div>
				</div>

				{
					this.state.viewImgVisible ? <div className="picCon">
					<div className="picConb">
						<span className="setwin" onClick={() => this.toggleViewImg('', false)}><i className="close2"></i></span>
						<div className="staic">
					      <div className="imgWrap"><img src={this.state.viewImgSrc} /></div>
					    </div>
					</div>
				  </div> : null
				}
				</div>
		)
	}

	private async getDetailsData() {
		let apiUrl = config.MALLAPI + 'api/wshop/sample/details?';

		const r = await request({
			method: "get",
			url: `${apiUrl}offId=${this.state.id}`,
		})
		if(r.error_code === 0) {
			this.setState({
				detailsData: r.data
			}) 
		}		
	}	
	/**
	 * [toggleViewImg 显示隐藏大图]
	 * @param {[string]} src [大图地址]
	 * @param  {[boolean]} visible [显示隐藏]
	 */
	private toggleViewImg(src: string, visible: boolean) {
		this.setState({
			viewImgVisible: visible,
			viewImgSrc: src
		});
	}
}